// Polyfills must load before anything else — pdf.js needs them on older browsers
import './polyfills';

// Initialize Sentry next (before other imports) to capture all errors
import { initSentry } from './lib/sentry/config';
import { initPostHog } from './lib/posthog/config';
initSentry();
initPostHog();

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
